import { type FC, useEffect } from 'react';
import { type RouteComponentProps, useLocation } from 'wouter';

import AccountInformation from 'components/AccountInformation';
import AccountPageNavigation, {
  type Page,
} from 'components/AccountPageNavigation';
import ChangePassword from 'components/ChangePassword';
import AccountLayout from 'components/Layouts/Account';
import UserInfo from 'components/UserInfo';

import styles from './ProfilePage.module.scss';

const sections: Page[] = [
  {
    title: 'personal_info',
    link: '~/account/profile/main',
  },
  {
    title: 'change_password',
    link: '~/account/profile/change-password',
  },
];

export enum ProfilePageSection {
  main = 'main',
  'change-password' = 'change-password',
}

type ProfilePageParams = {
  section: ProfilePageSection;
};

const ProfilePage: FC<RouteComponentProps<ProfilePageParams>> = ({
  params,
}) => {
  const [_, setLocation] = useLocation();
  useEffect(() => {
    if (!ProfilePageSection[params.section]) {
      setLocation(sections[0].link, { replace: true });
    }
  }, [params.section, setLocation]);

  return (
    <AccountLayout title="account_information" icon="tag-user.bold">
      <div className={styles.header}>
        <AccountPageNavigation pages={sections} />
        <UserInfo className={styles['user-info']} />
      </div>
      {params.section === ProfilePageSection.main && <AccountInformation />}
      {params.section === ProfilePageSection['change-password'] && (
        <ChangePassword />
      )}
    </AccountLayout>
  );
};

export default ProfilePage;
